export default {
  titles: {
    default: 'Promemoria ordine programmato!',
    external_delivery: 'Autista assegnato!',
  },
  labels: {
    pickup: 'Ritiro: {{time}}',
    preparation_time: 'Tempo di preparazione: {{time}} min',
  },
  buttons: {
    confirm: 'Inizia a preparare ora',
    print_and_confirm: 'Stampa e inizia a preparare ora',
  },
  toasts: {
    something_went_wrong: 'Qualcosa è andato storto, riprova',
  },
};
